module.exports = __webpack_public_path__ + "static/img/shixuncode.5de25ef3.png";